/**
 * @desc undefined
 */
import {
  TemplateVariableEntity,
  ListTemplateVariableParam
} from '@eastcoal/api/contract/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryTemplateVariableListParameter = ListTemplateVariableParam

const method = 'GET'
const url = '/contract/templateVariable/list'

export const queryTemplateVariableListApi = (
  params?: QueryTemplateVariableListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<TemplateVariableEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryTemplateVariableListApi.method = method
queryTemplateVariableListApi.url = url
